import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setSubscriberAddress, setFileSigned, checkOwnershipTransferSignatureFile } from '../OwnershipTransferCustomerSlice';
import TextInput from '../../../Shared/TextInput/TextInput';
import { OwnershipTransferCustomerStep } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import AddressForm from '../../SaleJetBlock/Partials/AddressForm/AddressForm';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const CustomerAddress = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.AddressPage,
        messageText: DWHMessageText.AddressPageDisplayed,
        status: DWHStatus.Ongoing
      });
    }
  }, []);
  const [isSubmit, setIsSubmit] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [showFileErrorMsg, setShowFileErrorMsg] = useState(false);
  const [showForm, setShowForm] = useState(false);
  let footer = document.getElementsByClassName('footer-container')[0];
  let el = document.getElementsByClassName('ownershipTransfer')[0];


  async function setCustomerAddress(res) {
    setIsSubmit(false);
    const address = {
      city: res.selectedAddress.cityName,
      street: res.selectedAddress.streetName,
      houseNum: res.selectedAddress.home,
      zipCode: res.selectedAddress.zipCode,
      apartment: res.selectedAddress.apartment,
    };

    if (Object.values(address).some((value) => value.trim() !== '')) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails },
        actionType: DwhActionType.AddressPage,
        messageText: DWHMessageText.AddressPageClicked,
        status: DWHStatus.Ongoing
      });
      await props.setSubscriberAddress(address);
      setShowErrorMsg(false);
      setShowFileErrorMsg(false)
      const validateFileStatus = {
        PhoneNumber: props.userDetails.contactNumber,
        Email: props.data.subscriberPersonalData.email,
        RequestId: props.data.requestId,
        FileGuid: props.data.signatureFile.guid,
        RequestType: 1
      }
      await props.checkOwnershipTransferSignatureFile(validateFileStatus)
        .then((res) => {
          if (res.payload.isSigned) {
            props.setCurrentStep(OwnershipTransferCustomerStep.CustomerPaymentMethod);
          }
          else {
            setShowFileErrorMsg(true)
          }
        })
    }
    else {
      setShowErrorMsg(true);
    }
  }
  const handleEventInNewTab = (event) => {
    if (event.data.type === 'ESignStatus') {
      if (event.data.status == "ok") {
        setShowFileErrorMsg(false);
        setShowForm(false);
        props.setFileSigned(true);
        window.removeEventListener('message', handleEventInNewTab);
        if (el) {
          el.classList.remove('fileOpen');
        }
        if (footer) {
          footer.style.display = '';
        }

      }
    }
  }
  window.addEventListener('message', handleEventInNewTab);


  function showSignatureForm() {
    dwhGeneralReport({
      data: { ...props.data, userDetails: props.userDetails },
      actionType: DwhActionType.AddressPage,
      messageText: DWHMessageText.AddressPageSignatureButtonClicked,
      status: DWHStatus.Ongoing
    });
    setShowForm(true)
    if (el) {
      el.classList.add('fileOpen');
    }
    if (footer) {
      footer.style.display = 'none';
    }

  }
  return (
    <div className='ownership-transfer-form'>
      {showForm && <div><iframe className="transfer-form" src={props.data.signatureFile.url}></iframe></div>}
      <div className='stepContainer'>
        <div className='l-title center'>מה הכתובת?</div>
        <div className='m-title center'> אנחנו צריכים אותה כדי לפתוח לך חשבון</div>

        <div>
          <AddressForm
            isSubmit={isSubmit}
            onSubmit={(res) => setCustomerAddress(res)}
            selectedAddress={{
              cityName: props.data.subscriberPersonalData?.city ?? '',
              streetName: props.data.subscriberPersonalData?.street ?? '',
              home: props.data.subscriberPersonalData?.houseNum ?? '',
              apartment: props.data.subscriberPersonalData?.apartment ?? '',
            }}
          />
        </div>
        <div className='digital-signature'>
          <div className='m-title semi'>חתימה על טופס העברת בעלות ואישור התנאים</div>
          <div className='s-title'> בכדי להמשיך בתהליך יש לחתום על הטופס בלחיצה על  על הכפתור מטה</div>
          <div className={`signature-file-btn ${props.data.signatureFile.isSigned ? 'signed' : ''}`}>
            <BtnSubmit onclick={() => !props.data.signatureFile.isSigned ? showSignatureForm() : null} text={'טופס העברת בעלות לחתימה'} />
          </div>
        </div>

        <div className='continue-button'>
          {showErrorMsg && <div className='error center'>כדי להמשיך יש למלא את כל שדות החובה</div>}
          {showFileErrorMsg && <div className='error center'>כדי להמשיך יש לחתום על טופס העברת בעלות</div>}
          <BtnSubmit onclick={() => setIsSubmit(true)} text={'אפשר להמשיך'} />
        </div>
      </div>

    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferCustomer,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSubscriberAddress,
  setFileSigned,
  checkOwnershipTransferSignatureFile
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAddress);
